import React, { Component } from 'react';

class SubmitFeed extends Component {
    render() {
        const { loading, onSubmit, onBack, disabled, hideSubmit } = this.props;

        return (
            <div className="ob-step-footer d-flex align-items-center">
                <button type="button" className="ob-btn-dark-outline" disabled={loading} onClick={!loading ? onBack : null}>Change source</button>
                {!hideSubmit && (
                    <div
                        className="ob-btn-wrap position-relative"
                        style={disabled && !loading ? { cursor: 'not-allowed' } : {}}
                        onClick={() => {
                            if (!loading && disabled && onSubmit) {
                                onSubmit(true);
                            }
                        }}
                    >
                        <button type="button" className="ob-btn-gradient d-flex align-items-center justify-content-center gap-2" disabled={loading || disabled} id="create_feed" onClick={!loading && !disabled ? () => onSubmit() : null}>
                            {loading && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>}
                            Collect content
                        </button>
                    </div>
                )}
            </div>
        )
    }
}

export default SubmitFeed;
